export const getPage = (items, pageNumber, itemsPerPage) => {
  const pageStart = (pageNumber - 1) * itemsPerPage
  const pageEnd = pageNumber * itemsPerPage
  return items.slice(pageStart, pageEnd)
}

export const getLastPageFetched = (items, itemsPerPage) =>
  Math.ceil(items.length / itemsPerPage)

export const getTotalPages = (totalItems, itemsPerPage) =>
  Math.ceil(totalItems / itemsPerPage)

export const getEntriesToFetch = (targetPage, lastPageFetched, itemsPerPage) =>
  itemsPerPage * (targetPage - lastPageFetched)

export const hasNextPage = (pageNumber, totalItems, itemsPerPage) =>
  pageNumber * itemsPerPage < totalItems
